export default __webpack_public_path__ + "static/media/pic-4.e3369b96.jpg";